<section id="home">
    <div class='home-screen'>
        <div class='login-div'>
            <div class='home-login'>
                <router-outlet></router-outlet>
            </div>
        </div>
    </div>
</section>
